import React from "react";
// Changed 'Router' alias to 'BrowserRouter' for clarity and future flag support
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import ScrollToTop from "./ScrollToTop";
import HotelPartnership from "./pages/HotelPartnership";
import Home from "./Home";
import CustomTripPlanner from "./pages/CustomTripPlanner";
import AIItinerary from "./AIItinerary";
import PricingPlans from "./PricingPlans";
import PaymentPage from "./PaymentPage";
import GlobeView from "./globeview";
import InfluencerJoin from "./pages/InfluencerJoin";

import BlogPage from "./pages/BlogPage";
import BlogDetails from "./pages/BlogDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import CorporateTravelFormModal from "./components/CorporateTravelFormModal.js";
import DestinationWeddingFormModal from "./components/DestinationWeddingFormModal.js";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import Disclaimer from "./pages/Disclaimer";

import Footer from "./components/Footer";
import HotelCollabForm from "./pages/HotelCollabForm";
import IndiaDestinations from "./pages/IndiaDestinations";
import AsiaDestinations from "./pages/AsiaDestinations";
import EuropeDestinations from "./pages/EuropeDestinations";

// Import New Hotel Collaboration Pages
import HotelCollaborations from "./pages/HotelCollaborations";
import CollaborationDetail from "./pages/CollaborationDetail";

function CorporateFormRoute() {
  const navigate = useNavigate();
  console.log("CorporateFormRoute mounted");
  return (
    <CorporateTravelFormModal
      isOpen={true}
      onRequestClose={() => navigate(-1)} // closes modal and goes back
    />
  );
}

function App() {
  return (
    /* 
       Updated with Future Flags to opt-in to v7 early and clear console warnings:
       1. v7_startTransition: Wraps state updates in startTransition.
       2. v7_relativeSplatPath: Updates relative route resolution within splat routes.
    */
    <BrowserRouter 
      future={{ 
        v7_startTransition: true, 
        v7_relativeSplatPath: true 
      }}
    >
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AIItinerary" element={<AIItinerary />} />
        <Route path="/plan-your-trip" element={<CustomTripPlanner />} />
        <Route path="/PricingPlans" element={<PricingPlans />} />
        <Route path="/PaymentPage" element={<PaymentPage />} />
        <Route path="/globe" element={<GlobeView />} />
        <Route path="/hotel-partnership" element={<HotelPartnership />} />
        <Route path="/join-influencer" element={<InfluencerJoin />} />
        <Route path="/HotelCollabForm" element={<HotelCollabForm />} />
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        
        {/* Hotel Collaborations Routes */}
        <Route path="/collaborations" element={<HotelCollaborations />} />
        <Route path="/collaborations/:hotelId" element={<CollaborationDetail />} />

        <Route
          path="/CorporateTravelFormModal"
          element={<CorporateFormRoute />}
        />
        <Route
          path="/DestinationWeddingFormModal"
          element={<DestinationWeddingFormModal />}
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/destinations/india" element={<IndiaDestinations />} />
        <Route path="/destinations/asia" element={<AsiaDestinations />} />
        <Route path="/destinations/europe" element={<EuropeDestinations />} />
      </Routes>

      {/* Footer appears on every page */}
      <Footer />
    </BrowserRouter>
  );
}

export default App;
